const host =  process.env.REACT_APP_API_ENDPOINT ?? "";

export default host;

export const getURI = (path) => {
    return host.concat(path);
}